var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgReaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3371 12.5026C8.30019 12.5026 8.26533 12.5005 8.22841 12.4944C7.97411 12.4595 7.75263 12.3098 7.62548 12.0883L4.35859 6.37281C4.133 5.97906 4.2704 5.47866 4.66415 5.25308C5.0579 5.02749 5.55829 5.1649 5.78388 5.55865L8.51552 10.3411L18.5849 0.240969C18.9048 -0.0789526 19.4236 -0.0810034 19.7456 0.238918C20.0655 0.55884 20.0676 1.07769 19.7476 1.39966L8.95644 12.2237L8.91747 12.2626C8.76161 12.4185 8.55243 12.5026 8.3371 12.5026Z",
    fill: "#00B84A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0871 12.5026C4.05019 12.5026 4.01533 12.5005 3.97841 12.4944C3.72411 12.4595 3.50263 12.3098 3.37548 12.0883L0.108587 6.37281C-0.116999 5.97906 0.0204035 5.47866 0.414153 5.25308C0.807903 5.02749 1.30829 5.1649 1.53388 5.55865L4.26552 10.3411L14.3349 0.240969C14.6548 -0.0789526 15.1736 -0.0810034 15.4956 0.238918C15.8155 0.55884 15.8176 1.07769 15.4976 1.39966L4.70644 12.2237L4.66747 12.2626C4.51161 12.4185 4.30243 12.5026 4.0871 12.5026Z",
    fill: "#00B84A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgReaded);
export default __webpack_public_path__ + "static/media/msg-readed.6dc1ee05475f0c07780100d2c6bb590e.svg";
export { ForwardRef as ReactComponent };